<app-back-button></app-back-button>
<div class="contents">
  <!-- ════ PAGE HEADER ════ -->
  <div class="page-header">
    <div>
      <h1 class="page-header-title">Gestão de Pagamentos</h1>
      <p class="page-header-sub">Confira os pagamentos realizados, apoios e estado das transações</p>
    </div>

    <div class="page-header-actions">
      <div class="header-stat-pill">
        <i class="fas fa-hand-holding-dollar text-primary"></i>
        <span>Volume Total: <strong>AOA {{ valorTotal | money }}</strong></span>
      </div>
    </div>
  </div>

  <!-- Estatísticas de Apoios / Pagamentos -->
  <div class="pagamento-stats-container mb-4" *ngIf="!loadingStats">
    <div class="stats-card">
      <div class="stats-badge primary">
        <i class="fas fa-receipt"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Total de Apoios</span>
        <span class="stats-value">{{ totalApoios }}</span>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-badge success">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Confirmados</span>
        <span class="stats-value text-green">{{ totalConfirmados }}</span>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-badge warning">
        <i class="fas fa-clock"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Pendentes</span>
        <span class="stats-value text-amber">{{ totalPendentes }}</span>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-badge danger">
        <i class="fas fa-times-circle"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Cancelados</span>
        <span class="stats-value text-red">{{ totalCancelados }}</span>
      </div>
    </div>
  </div>

  <app-lista-pagamentos></app-lista-pagamentos>
</div>